import { cva } from 'class-variance-authority';
import { cn } from '@/lib/utils.js';

// Per spec §3 carrier badge state vocab — these variants map 1:1 to the
// locked states (awaiting/received/declined/revised/discussing/submitted/
// not-submitted). Plus generic stage/status pills.
const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-pill px-2.5 py-0.5 text-xs font-medium leading-none',
  {
    variants: {
      variant: {
        default: 'bg-border/60 text-text',
        outline: 'border border-border text-text-muted',
        dashed: 'border border-dashed border-border text-text-muted',
        accent: 'bg-accent-soft text-accent',
        success: 'bg-success-soft text-success',
        warning: 'bg-warning-soft text-warning',
        info: 'bg-info-soft text-info',
        muted: 'bg-border/40 text-text-dim line-through',
      },
    },
    defaultVariants: { variant: 'default' },
  }
);

function Badge({ className, variant, ...props }) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
